<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">存取记录</div>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-row>
          <el-form-item label="时间段" prop="date">
            <el-date-picker
              v-model="date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 68rem"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="eventTime"
              label="发生时间"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="accessType"
              label="存取状态"
              align="center"
              :formatter="formatAccessType"
            ></el-table-column>
            <el-table-column
              prop="tagName"
              label="柜格标签"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              label="设备名称"
              align="center"
            ></el-table-column>
            <el-table-column
              label="事件抓拍"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.operateImage"
                  :src="scope.row.operateImage"
                  :preview-src-list="[scope.row.operateImage]"
                  style="width: 60px; height: 60px"
                  fit="cover"
                ></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listAccessRecords } from "../../../apis/src/CabinetApi";
export default {
  name: "AccessRecordView",
  controller: "UI",
  action: "accessRecordView",
  data() {
    return {
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [],
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      this.searching = true;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        eventTimeStart: this.date && this.date.length === 2 ? this.date[0] : undefined,
        eventTimeEnd: this.date && this.date.length === 2 ? this.date[1] : undefined,
      };
      listAccessRecords(params)
        .then((r) => {
          this.searching = false;
          let vo = r.data || {};
          let data = vo.data || {};
          this.tableData = data.list || [];
          this.total = data.total || 0;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    onCancel() {
      this.date = [];
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data === "") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    formatAccessType(row, column) {
      let data = row[column.property];
      if (data === "Deposit") {
        return "存";
      }
      if (data === "Retrieve") {
        return "取";
      }
      return data || "-";
    },
  },
};
</script>
